
/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  GeneralBarometer,
  JobBarometer,
} from '../models';
import {
    GeneralBarometerFromJSON,
    GeneralBarometerToJSON,
    JobBarometerFromJSON,
    JobBarometerToJSON,
} from '../models';

export interface GeneralBarometerRequest {
    urlPrefix: string;
    locale?: string;
}

export interface JobBarometerRequest {
    urlPrefix: string;
    familyId: string;
    categoryId?: string;
    subCategoryId?: string;
    locale?: string;
}

/**
 * 
 */
export class BarometerApi extends runtime.BaseAPI {

    /**
          */
    async generalBarometerRaw(requestParameters: GeneralBarometerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<GeneralBarometer>> {
        if (requestParameters['urlPrefix'] == null) {
            throw new runtime.RequiredError(
                'urlPrefix',
                'Required parameter "urlPrefix" was null or undefined when calling generalBarometer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['urlPrefix'] != null) {
            queryParameters['urlPrefix'] = requestParameters['urlPrefix'];
        }

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<GeneralBarometer>({
            path: `/cms/api/barometer/general/{urlPrefix}`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=GeneralBarometerFromJSON(response._data); }
        return response;
    }

    /**
          */
    async generalBarometer(requestParameters: GeneralBarometerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<GeneralBarometer> {
        const response = await this.generalBarometerRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async jobBarometerRaw(requestParameters: JobBarometerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<JobBarometer>> {
        if (requestParameters['urlPrefix'] == null) {
            throw new runtime.RequiredError(
                'urlPrefix',
                'Required parameter "urlPrefix" was null or undefined when calling jobBarometer().'
            );
        }

        if (requestParameters['familyId'] == null) {
            throw new runtime.RequiredError(
                'familyId',
                'Required parameter "familyId" was null or undefined when calling jobBarometer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['urlPrefix'] != null) {
            queryParameters['urlPrefix'] = requestParameters['urlPrefix'];
        }

        if (requestParameters['familyId'] != null) {
            queryParameters['familyId'] = requestParameters['familyId'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['subCategoryId'] != null) {
            queryParameters['subCategoryId'] = requestParameters['subCategoryId'];
        }

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<JobBarometer>({
            path: `/cms/api/barometer/job`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=JobBarometerFromJSON(response._data); }
        return response;
    }

    /**
          */
    async jobBarometer(requestParameters: JobBarometerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<JobBarometer> {
        const response = await this.jobBarometerRaw(requestParameters, initOverrides);
        return response._data;
    }

}
